// Sun position. Shared by solar output (sim) and the day/night tint (render).
export const SUNRISE = 6;
export const SUNSET = 19;

/** 0 at night, rising to 1 at solar noon, back to 0 at sunset. */
export function sunAltitude(hour: number): number {
  const h = ((hour % 24) + 24) % 24;
  if (h <= SUNRISE || h >= SUNSET) return 0;
  return Math.sin((Math.PI * (h - SUNRISE)) / (SUNSET - SUNRISE));
}

export function isDaytime(hour: number): boolean {
  return sunAltitude(hour) > 0;
}
